<script setup lang="ts">
import { ref, toRefs } from 'vue'
import type { TInstallment, TOptions, TProductData } from './ProductsGridTypes'

const props = defineProps<{
    data: TProductData
}>()
const { data } = toRefs(props)

const selected = ref(data.value.installmentStart)

const currentInstallmentDataToDisplay = computed(() =>
    data.value?.installments.find((item: TInstallment) => Number(selected.value) === item.installmentNo),
)

/*
 *Options RadioInputs
 */
const options = ref<TOptions[]>([])
function generateOptions(installments: TInstallment[]) {
    return installments.map((installment) => ({
        value: installment.installmentNo,
        label: installment.installmentPrice,
    }))
}
if (data.value.installments) {
    options.value = generateOptions(data.value?.installments)
}
</script>

<template>
    <div class="flex flex-col justify-between rounded-xl bg-white shadow-plush-1">
        <div class="my-5">
            <AtomImage
                :src="data.image"
                :alt="data.name"
                img-class="mx-auto"
            />
        </div>
        <section class="p-5">
            <h4
                class="text-neutral-primary mb-2 text-xl font-bold"
                v-html="data.name"
            />
            <template v-if="data.price">
                <p class="text-plush-pink my-2 text-3xl font-bold">{{ data.price }}</p>
            </template>
            <template v-if="data.omnibusText">
                <p class="text-paragraph-sm mb-2">{{ data.omnibusText }}</p>
            </template>
            <template v-if="data.installments">
                <p
                    class="text-xl font-bold"
                    v-html="currentInstallmentDataToDisplay.initialPrice"
                />
                <p
                    v-if="currentInstallmentDataToDisplay.installmentPrice"
                    class="text-plush-pink text-heading-lg mb-2 font-bold"
                >
                    {{ currentInstallmentDataToDisplay.installmentPrice }}
                    <span
                        class="text-neutral-primary text-base font-bold"
                        v-html="currentInstallmentDataToDisplay.installmentPriceSuffixText"
                    />
                </p>
                <div class="text-neutral-primary my-6">
                    <p
                        class="text-paragraph-sm font-normal"
                        v-html="currentInstallmentDataToDisplay.hardwarePrice"
                    />
                    <p class="text-paragraph-sm">{{ currentInstallmentDataToDisplay.omnibusText }}</p>
                </div>
                <div class="my-6">
                    <p
                        class="text-paragraph-md font-normal"
                        v-html="data.installmentNoLabel"
                    />

                    <URadioGroup
                        v-model="selected"
                        :options="options"
                        :ui="{ fieldset: 'flex flex-row gap-5' }"
                        class="radio-group ml-4"
                    >
                        <template #label="{ option }">
                            <p class="text-base font-normal">
                                {{ option.value }}
                            </p>
                        </template>
                    </URadioGroup>
                </div>
            </template>

            <VButton
                variant="primary"
                size="medium"
                data-test="blog"
            >
                {{ data.cta }}
            </VButton>
        </section>
    </div>
</template>

<style scoped>
.text-plush-pink {
    color: #c30f6d;
}
</style>
